<div class="main-container" @fadeIn>
	<div class="main-form">
		<app-loader [hasTransparency]="true" *ngIf="isSaving"></app-loader>
		<ng-container *ngIf="!isDeleteSucceeded && !isDeleteFailed; else deleteStatusTemplate">
			<div class="unregister-header">
				<h3>Important Notice Before Deleting Your Account</h3>
			</div>

			<div><strong>User:</strong> {{userInfo.userName}}</div>
			<div><strong>Account:</strong> {{userInfo.accountName}}</div>

			<div class="delete-msg">
				Deleting your account is a <strong>permanent action</strong> and <strong>cannot be undone</strong>.
			</div>

			<div>
				Once you proceed:
			</div>
			<div class="delete-info">
				- <strong>You will no longer be able to access Vitralogy services</strong>
				using this account.
			</div>
			<div class="delete-info">
				- All your data, settings, and content associated with this account will
				<strong>
					be permanently deleted
				</strong>.
			</div>
			<div class="delete-info">
				- <strong>Before requesting deletion</strong>, please ensure you have
				<strong>
					logged out of all apps/services
				</strong>
				that use this account to prevent any unexpected behavior.
			</div>
			<div class="delete-confirmation-msg">If you are certain you want to delete your account, please type
				<strong>delete</strong> in the box below.
			</div>
			<div>
				<form>
					<mat-form-field>
						<input matInput [(ngModel)]="deleteInput" name="deleteInput" />
					</mat-form-field>
				</form>
			</div>
			<div class="form-button-container">
				<button class="delete-button" mat-raised-button type="button" [disabled]="isSaving" color="error"
					(click)="onDelete()">
					Delete account
				</button>
			</div>
		</ng-container>
		<ng-template #deleteStatusTemplate>
			<div *ngIf="isDeleteSucceeded">
				<div class="unregister-header">
					<h3>Account successfully deleted</h3>
				</div>
				<div class="icon-wrapper">
					<mat-icon class="success-icon" svgIcon="check"></mat-icon>
				</div>
			</div>
			<div *ngIf="isDeleteFailed">
				<div class="unregister-header">
					<h3>Account deletion failed</h3>
				</div>
				<div class="icon-wrapper">
					<mat-icon class="failed-icon" svgIcon="cancel"></mat-icon>
				</div>
			</div>
		</ng-template>
	</div>
</div>